import React from 'react';
import { Button } from './ui/button';
import { Calendar, Check, Sparkles } from 'lucide-react';

const ConsultationCTA = () => {
  const benefits = [
    'Audit your current marketing setup',
    'Identify AI opportunities for automation',
    'Design a lean, high-output marketing system',
    'Get actionable recommendations you can implement immediately',
  ];

  return (
    <section id="consultation" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-teal-600 to-emerald-600 text-white">
      <div className="max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 mb-6 bg-white/10 px-4 py-2 rounded-full">
          <Sparkles size={20} />
          <span className="text-sm font-semibold">Free Consultation</span>
        </div>

        <h2 className="text-4xl sm:text-5xl font-bold mb-6">
          Ready to Build AI-Powered Marketing?
        </h2>
        <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto">
          Book a free 15-minute consultation. We will discuss your marketing challenges and I will show you 
          exactly how AI can help you scale without inflating headcount or budgets.
        </p>        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8 max-w-2xl mx-auto">
          <h3 className="text-2xl font-bold mb-6">What You Will Get:</h3>          <div className="grid gap-4 text-left">            {benefits.map((benefit, index) => (              <div key={index} className="flex items-start gap-3">                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">                  <Check size={16} />                </div>                <span className="text-lg">{benefit}</span>              </div>            ))}          </div>        </div>        <Button          onClick={() => window.open('https://calendly.com/scalewithanshul/30min', '_blank')}          size="lg"          className="bg-white text-teal-600 hover:bg-slate-100 px-12 h-16 text-xl font-bold shadow-2xl"        >          <Calendar className="mr-3" size={24} />          Book Your Free 15-Min Call        </Button>        <p className="text-sm text-white/70 mt-6">          No sales pitch. No obligations. Just honest advice on making your marketing smarter.        </p>      </div>    </section>  );};export default ConsultationCTA;
